<template>
  <div
    :id="`submenu-drawer--${menuId}`"
    :aria-hidden="open ? 'false' : 'true'"
    :class="['submenu-drawer', { 'submenu-drawer--open': open }]"
  >
    <slot />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'SubmenuDrawer',
    props: {
      menuId: { type: String, required: true }
    },
    data() {
      return {
        open: false
      };
    },
    computed: {
      ...mapGetters('menuStore', [
        'activeSubmenuId'
      ]),
    },
    watch: {
      activeSubmenuId(newId) {
        return newId === this.menuId ? this.updateDrawer(!this.open) : this.updateDrawer(false);
      }
    },
    methods: {
      updateDrawer(status) {
        this.open = status;
      }
    }
  };
</script>
